import { useSelector } from "react-redux";
import Flx from "../../components/layout/Flx";
import Txt from "../../components/typography/Txt";

import { isEmpty, size } from "lodash";
import FlxGrid from "../../_src_shared/components/layout/FlxGrid";
import ScreenContent from "../../components/layout/ScreenContent";
import Htag from "../../components/typography/Htag";
import QuickActionSubmitFinancingRequest from "./sections/QuickActionSubmitFinancingRequest";

import ActionRequiredAlert from "../../components/alerts/ActionRequiredAlert";
import ProfileRequirementsAlert from "../../components/alerts/ProfileRequirementsAlert";
import QuickActionCompleteProfile from "./sections/QuickActionCompleteProfile";
import QuickActionUploadLoanDocuments from "./sections/QuickActionUploadLoanDocuments";
import DashboardSection from "./shared/DashboardSection";
import SubmittedFinancingRequestsSection from "./SubmittedFinancingRequestsSection";

const DashboardHomeScreen = () => {
  const profile = useSelector((state) => state?.profile);

  const financingRequests = useSelector((state) => state?.financingRequests);

  return (
    <ScreenContent
      maxWidth={"xl"}
      sx={{
        width: "100%",
        py: 4,
        margin: "0px auto",
      }}
    >
      <Flx column gap={2} fw>
        <Flx column fw gap={1}>
          <Flx column flexGrow={0} fw={false} gap={1}>
            <Htag tag="h1" className="text-center">
              Welcome, {profile?.firstName}!
            </Htag>

            {isEmpty(financingRequests) ? (
              <Txt secondary>
                To get started, submit your first financing request by clicking
                the "Submit Financing Request" button below.
              </Txt>
            ) : (
              <Txt>
                You currently have ({size(financingRequests)}) financing
                requests in progress.
              </Txt>
            )}
            <ActionRequiredAlert />
            {/* <UnderwritingRequirementsAlert /> */}
            {/* <TermSheetReviewAlert /> */}
            <ProfileRequirementsAlert />
          </Flx>
        </Flx>
        {/* <DashboardWidgetsPreview /> */}
        <DashboardSection label={"Quick Actions"} sx={{ mt: 3 }}>
          <FlxGrid width="250px" gap={2} fw wrap>
            <QuickActionSubmitFinancingRequest />
            <QuickActionUploadLoanDocuments />
            {/* <QuickActionUploadProfileDocuments /> */}
            <QuickActionCompleteProfile />
          </FlxGrid>
        </DashboardSection>

        {/* <ActiveFinancingRequestsConditionsSection /> */}
        <SubmittedFinancingRequestsSection />
        {/* <OffMarketPropertyListingsSection /> */}
      </Flx>
    </ScreenContent>
  );
};

// Basic stat widget with icon

export default DashboardHomeScreen;
